module.exports = __webpack_public_path__ + "img/av_macaw.a05c791e.png";